
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/2014-09-20-long-exposure-under-the-ben-franklin",
      function () {
        return require("private-next-pages/posts/2014-09-20-long-exposure-under-the-ben-franklin.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/2014-09-20-long-exposure-under-the-ben-franklin"])
      });
    }
  